import { Group } from "../features/group/models/Group";
import { Package } from "../features/subscriptions/modules/packages/models/Package";
import { PackageGroup } from "../features/group/models/PackageGroup";
import { PackageGroupRequest } from "../features/group/models/PackageGroupRequest";
import { baanRueJaiClient } from "@/dependencies";

export class GroupUseCase {
  /**
   * @return {Group[]}
   */
  static async list() {
    const groupResponses = await baanRueJaiClient.admin.groups.packageGroups.list();

    return groupResponses.map(groupResponse =>
      Group.createFromResponse(groupResponse)
    );
  }

  /**
   * @param {string} groupId
   *
   * @return {PackageGroup}
   */
  static async getPackageGroup(groupId) {
    const packageGroupResponse = await baanRueJaiClient.admin.groups.packageGroups.get(
      groupId
    );

    return PackageGroup.createFromResponse(packageGroupResponse);
  }

  /**
   * @return {Package[]}
   */
  static async getAllPackage() {
    const allPackageResponse = await baanRueJaiClient.admin.groups.packageGroups.getAllPackage();

    return allPackageResponse.map(packageResponse =>
      Package.createFromResponse(packageResponse)
    );
  }

  /**
   * @param {String} id
   * @param {String[]} packageIds
   */
  static async updatePackageGroup(id, packageIds) {
    const params = new PackageGroupRequest(packageIds);

    await baanRueJaiClient.admin.groups.packageGroups.put(id, params);
  }

  /**
   * @param {String} id
   */
  static async cancelPackageGroup(id) {
    const cancelGroup = await baanRueJaiClient.admin.groups.packageGroups.delete(
      id
    );
    return cancelGroup.data.message;
  }

  static async post(params) {
    await baanRueJaiClient.admin.groups.packageGroups.post(params);
  }
}



// WEBPACK FOOTER //
// ./src/usecases/GroupUseCase.js